import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Play, Lock, ArrowLeft, ArrowRight, Eye } from 'lucide-react';
import { useLang, pickLocalized, tx } from '../../i18n/LanguageContext';
import { colorFor } from '../articles/articleUtils';

export const VideoCard = ({ video, categories, getLabel, locked, index }) => {
  const { lang, isRTL } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const Arrow = isRTL ? ArrowLeft : ArrowRight;
  const cat = video.categories[0];
  return (
    <div className="art-reveal flex" style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}>
      <Link to={`/library/video/${video.id}`} data-testid={`video-card-${video.id}`} style={{ '--glow': '#2563eb' }}
        className="plan-glow group w-full flex flex-col bg-white rounded-2xl border border-slate-200/80 p-2.5 shadow-[0_6px_24px_-12px_rgba(15,23,42,0.15)] outline-none">
        <div className="relative aspect-video overflow-hidden rounded-xl bg-gradient-to-br from-slate-800 via-slate-900 to-blue-950">
          {video.poster
            ? <img src={video.poster} alt="" loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            : video.url ? <video src={video.url} muted playsInline preload="metadata" className="w-full h-full object-cover" />
            : <div className="absolute inset-0 hero-grid-dark opacity-60" />}
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent flex items-center justify-center">
            <span className={`w-14 h-14 rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform ${locked ? 'bg-amber-400' : 'bg-white/95'}`}>
              {locked ? <Lock className="w-6 h-6 text-slate-900" /> : <Play className="w-6 h-6 text-rose-500 fill-rose-500 ms-0.5" />}
            </span>
          </div>
          <span className={`absolute top-2.5 start-2.5 px-3 py-1 rounded-lg text-xs font-bold shadow-sm ${colorFor(categories, cat).pill}`}>{getLabel(cat, lang)}</span>
        </div>
        <div className="flex-1 flex flex-col px-2.5 pt-4 pb-1">
          <h3 className="text-slate-900 font-black text-base sm:text-lg leading-snug mb-2 line-clamp-2 group-hover:text-blue-700 transition-colors">{pickLocalized(video.title, lang)}</h3>
          <p className="text-slate-500 text-sm leading-relaxed line-clamp-2 mb-4 flex-1">{pickLocalized(video.excerpt, lang)}</p>
          <div className="flex items-center justify-between text-xs text-slate-500 mb-3">
            <span className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /><span dir="ltr">{video.date}</span></span>
            {video.views > 0 && <span className="flex items-center gap-1.5" data-testid={`video-views-${video.id}`}><Eye className="w-3.5 h-3.5" />{video.views.toLocaleString('en-US')}</span>}
          </div>
          <span className="h-10 rounded-xl bg-blue-50 group-hover:bg-blue-600 text-blue-700 group-hover:text-white font-bold text-sm inline-flex items-center justify-center gap-2 transition-colors">
            {L('شاهد الآن', 'Watch now')}<Arrow className="w-4 h-4" />
          </span>
        </div>
      </Link>
    </div>
  );
};
